// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
html {
  padding: 0;
  margin: 0;
}

body {
  font-family: "Poppins", sans-serif;
  background-color: white;
  margin: 0;
  min-height: 100vh;
}

/*
  AppBar
*/

.app-bar {
  padding: 8px 16px;
  background-color: #ffde59;
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 10px;
  position: sticky;
  top: 0;
  z-index: 99;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}

.app-bar .app-bar__menu {
  display: flex;
  align-items: center;
}

.app-bar .app-bar__menu button {
  background-color: transparent;
  border: none;
  font-size: 18px;
  padding: 8px;
  cursor: pointer;
}

.app-bar .app-bar__brand .logo {
  width: 50px;
  height: 50px;
  margin-right: 10px;
}

.app-bar .app-bar__brand {
  display: flex;
  align-items: center;
}

.app-bar .app-bar__brand p {
  color: #000;
  font-size: 26px;
  font-weight: 700;
  margin: 0;
}

.app-bar .app-bar__navigation {
  position: absolute;
  top: 50px;
  left: -180px;
  width: 150px;
  transition: all 0.3s;
  padding: 8px;
  background-color: #ffde59;
  overflow: hidden;
}

.app-bar .app-bar__navigation.open {
  left: 0;
}

.app-bar .app-bar__navigation ul li a {
  display: inline-block;
  text-decoration: none;
  color: black;
  padding: 8px;
  margin-bottom: 5px;
  width: 100%;
}

.app-bar .app-bar__navigation ul li a:hover {
  background-color: #fed944;
  font-weight: bold;
}

/* 
    Carousel
*/

.carousel-inner:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
}

/*
  Main Content
*/

/* Footer */
.row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 50px;
}

ul {
  list-style: none;
  padding: 0;
}

footer {
  background-color: #ffde59;
  padding-top: 50px;
}

.single-box h4 {
  font-size: 18px;
  color: #000000;
  text-transform: capitalize;
  margin-bottom: 20px;
  margin-right: 0px;
  font-weight: 700;
  padding-bottom: 10px;
  border-bottom: 2px solid #ff8a00;
  width: 55%;
}

.single-box ul li:not(:last-child) {
  margin-bottom: 10px;
}

.single-box ul li a,
.single-box p {
  font-size: 16px;
  text-transform: capitalize;
  color: #000000;
  text-decoration: none;
  font-weight: 300;
  color: #000000;
  display: block;
  transition: all 0.3s ease;
}

.single-box ul li a:hover {
  color: #ff8a00;
  padding-left: 8px;
}

.single-box img {
  width: 55px;
  height: 70px;
  padding: 8px;
}

hr {
  border: 1px solid #ff8a00;
  width: 100%;
  margin: 0 auto;
}

/* Footer-Copyright */
footer .footer-copyright {
  text-align: center;
  color: #000;
  padding: 10px;
}

/*CSS PETA RESPONSIVE */
.peta-responsive {
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
  height: 0;
}

.peta-responsive iframe {
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
}

/* section-activities */
.section-header-activities,
.section-header-facilities {
  background-color: #ffde59;
  padding: 20px 0px 10px 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/style.css"],"names":[],"mappings":"AAAA;;EAEE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;;AAEA;;CAEC;;AAED;EACE,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;CAEC;;AAED;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,8BAA8B;AAChC;;AAEA;;CAEC;;AAED,WAAW;AACX;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,0BAA0B;EAC1B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,OAAO;EACP,MAAM;EACN,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;;EAEE,yBAAyB;EACzB,wBAAwB;AAC1B","sourcesContent":["*,\nhtml {\n  padding: 0;\n  margin: 0;\n}\n\nbody {\n  font-family: \"Poppins\", sans-serif;\n  background-color: white;\n  margin: 0;\n  min-height: 100vh;\n}\n\n/*\n  AppBar\n*/\n\n.app-bar {\n  padding: 8px 16px;\n  background-color: #ffde59;\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 10px;\n  position: sticky;\n  top: 0;\n  z-index: 99;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);\n}\n\n.app-bar .app-bar__menu {\n  display: flex;\n  align-items: center;\n}\n\n.app-bar .app-bar__menu button {\n  background-color: transparent;\n  border: none;\n  font-size: 18px;\n  padding: 8px;\n  cursor: pointer;\n}\n\n.app-bar .app-bar__brand .logo {\n  width: 50px;\n  height: 50px;\n  margin-right: 10px;\n}\n\n.app-bar .app-bar__brand {\n  display: flex;\n  align-items: center;\n}\n\n.app-bar .app-bar__brand p {\n  color: #000;\n  font-size: 26px;\n  font-weight: 700;\n  margin: 0;\n}\n\n.app-bar .app-bar__navigation {\n  position: absolute;\n  top: 50px;\n  left: -180px;\n  width: 150px;\n  transition: all 0.3s;\n  padding: 8px;\n  background-color: #ffde59;\n  overflow: hidden;\n}\n\n.app-bar .app-bar__navigation.open {\n  left: 0;\n}\n\n.app-bar .app-bar__navigation ul li a {\n  display: inline-block;\n  text-decoration: none;\n  color: black;\n  padding: 8px;\n  margin-bottom: 5px;\n  width: 100%;\n}\n\n.app-bar .app-bar__navigation ul li a:hover {\n  background-color: #fed944;\n  font-weight: bold;\n}\n\n/* \n    Carousel\n*/\n\n.carousel-inner:before {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.7);\n}\n\n/*\n  Main Content\n*/\n\n/* Footer */\n.row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 50px;\n}\n\nul {\n  list-style: none;\n  padding: 0;\n}\n\nfooter {\n  background-color: #ffde59;\n  padding-top: 50px;\n}\n\n.single-box h4 {\n  font-size: 18px;\n  color: #000000;\n  text-transform: capitalize;\n  margin-bottom: 20px;\n  margin-right: 0px;\n  font-weight: 700;\n  padding-bottom: 10px;\n  border-bottom: 2px solid #ff8a00;\n  width: 55%;\n}\n\n.single-box ul li:not(:last-child) {\n  margin-bottom: 10px;\n}\n\n.single-box ul li a,\n.single-box p {\n  font-size: 16px;\n  text-transform: capitalize;\n  color: #000000;\n  text-decoration: none;\n  font-weight: 300;\n  color: #000000;\n  display: block;\n  transition: all 0.3s ease;\n}\n\n.single-box ul li a:hover {\n  color: #ff8a00;\n  padding-left: 8px;\n}\n\n.single-box img {\n  width: 55px;\n  height: 70px;\n  padding: 8px;\n}\n\nhr {\n  border: 1px solid #ff8a00;\n  width: 100%;\n  margin: 0 auto;\n}\n\n/* Footer-Copyright */\nfooter .footer-copyright {\n  text-align: center;\n  color: #000;\n  padding: 10px;\n}\n\n/*CSS PETA RESPONSIVE */\n.peta-responsive {\n  overflow: hidden;\n  padding-bottom: 56.25%;\n  position: relative;\n  height: 0;\n}\n\n.peta-responsive iframe {\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  position: absolute;\n}\n\n/* section-activities */\n.section-header-activities,\n.section-header-facilities {\n  background-color: #ffde59;\n  padding: 20px 0px 10px 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
